// extracted by mini-css-extract-plugin
module.exports = {"payment_method":"payment_payment_method__1b1CT","card":"payment_card__spUJ7"};